import "../sparkle_namespace.js";

window.Sparkle ??= {};

window.Sparkle.Tabs = (function initTabs() {
  // Don't initialize multiple times
  if (Sparkle.Tabs) {
    return Sparkle.Tabs;
  }

  var tabGroupSelector = '[role="tablist"]';
  var tabContentSelector = '[role="tabpanel"]';
  var tabSelector = "input:radio[data-behaviour=tabstate]";
  var tabNamePrefix = "tab_";

  // BEHAVIOUR

  jQuery(document).on("change", tabSelector, changeTabHandler);

  // EVENT HANDLERS

  function changeTabHandler(event) {
    jQuery(this)
      .closest(tabGroupSelector)
      .find(tabSelector)
      .each(function () {
        if (jQuery(this).is(":checked")) {
          makeSelected(this);
          var selectorsElement = jQuery(this).closest("[data-history]");
          if (selectorsElement.length && window.location.pathname !== "srcdoc") {
            var groupName = selectorsElement.data("group-name") || "tab";
            updateUrl(this, groupName, selectorsElement.data("history"));
            if (window.Form) {
              Form.updateReturnTo();
            }
          }
        } else {
          makeUnselected(this);
        }
      });
  }

  // HELPER FUNCTIONS

  function initializeTabs(container) {
    selectNeedyTabs(container);
    jQuery(container || document)
      .find(tabGroupSelector)
      .each(function (i, group) {
        var groupTabs = jQuery(group).find(tabSelector);
        if (groupTabs.filter(":checked").length == 0) {
          selectTab(groupTabs.first());
        }
      });
  }

  // If there is needy content in a tab, force that tab to display instead of the one selected by default
  function selectNeedyTabs(container) {
    jQuery(container || document)
      .find('[data-behaviour="needy-content"]')
      .each(function () {
        findTabsForElement(this).each(function () {
          selectTab(this);
        });
      });
  }

  function selectTabByName(name, group) {
    return selectTab(findTabByName(name, group));
  }

  // Dispatches a native change event so listeners added with `addEventListener` hear it as well as jQuery handlers.
  function selectTab(tab) {
    const tabs = jQuery(tab).prop("checked", true);

    tabs.get().forEach((element) => element.dispatchEvent(new Event("change", { bubbles: true })));

    return tabs;
  }

  function findTabsForElement(elementInContent) {
    return findTabsForContent(jQuery(elementInContent).closest(tabContentSelector));
  }

  // Callers iterate the result, so a miss is an empty set. A flat tab group renders its panel
  // as a region rather than a tabpanel and has no tab strip, so a needy element inside one
  // resolves to no tab and needs none: nothing in a flat group is hidden.
  function findTabsForContent(content) {
    var needyTabId = jQuery(content).attr("id");
    if (!needyTabId) {
      return jQuery();
    }

    return jQuery('[aria-controls="' + needyTabId + '"]');
  }

  function findTabByName(name, group) {
    var tabValue = tabNamePrefix + name;
    var tabs = jQuery(tabSelector).filter(function (_, tab) {
      return tab.value == tabValue;
    });

    if (group) {
      tabs = tabs.filter(function (_, tab) {
        return tab.name == group;
      });
    }

    if (tabs.length) {
      return tabs.first();
    } else {
      console.error("Tab not found:", name, group);
    }
  }

  function tabNames(group) {
    var groupSelector = "";
    if (group) {
      groupSelector = '[data-group-name="' + group + '"] ';
    }

    return jQuery(groupSelector + tabSelector)
      .toArray()
      .map((tab) => tab.value.replace(tabNamePrefix, ""));
  }

  function makeSelected(tab) {
    tab = jQuery(tab);
    tab.attr("aria-selected", true);
    jQuery("#" + tab.attr("aria-controls"))
      .show()
      .trigger("tab:shown", [tab[0]]);

    return tab;
  }

  function makeUnselected(tab) {
    jQuery(tab).removeAttr("aria-selected");
    jQuery("#" + jQuery(tab).attr("aria-controls"))
      .hide()
      .trigger("tab:hidden");
  }

  function updateUrl(tab, groupName, method) {
    if (typeof URL !== "function") {
      return;
    } // Old browser doesn't support URL object
    var url = new URL(window.location.href);
    url.searchParams.set(groupName, tab.value);
    history[method]("", "", url.toString());
  }

  // INITIALIZE

  jQuery(initializeTabs); // Initialize tabs once DOM is ready

  // PUBLIC INTERFACE

  return {
    initializeTabs: initializeTabs,
    selectTab: selectTab,
    selectTabByName: selectTabByName,
    tabNames: tabNames,
  };
})();
